import { useTranslations } from '@vocab/react';
import { Textarea } from 'braid-design-system';
import type { QuestionProps } from '../../type';
import { CHALLENGES_MAX_LENGTH } from '../../validation/validationRules';
import translations from './.vocab';

export const TheChallengesQuestion = ({
  value = '',
  message = '',
  tone,
  onChange,
}: QuestionProps) => {
  const { t } = useTranslations(translations);
  return (
    <Textarea
      id={'theChallenges'}
      label={t('The challenges')}
      description={t("Describe what you don't like")}
      onChange={(event) => onChange(event.currentTarget.value)}
      value={value}
      tone={tone}
      message={message}
      reserveMessageSpace
      characterLimit={CHALLENGES_MAX_LENGTH}
    />
  );
};
